<template>
  <div class="leaflet-map">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker v-for="resource in countries" :key="resource.id" :lat-lng="ll(resource.address.lat, resource.address.lon)">
        <l-popup>
          <div class="h3"><a :href="'/resources/view/' + resource.id">{{ resource.name }}</a></div>
          <div><strong>{{ l10n.technologies }}</strong> {{ resource.technologies.map(x => x.name).join(', ') }}</div>
          <div><strong>{{ l10n.audiences }}</strong> <span>{{ resource.audiences.map(x => x.name).join(', ') }}</span></div>
        </l-popup>
      </l-marker>
      
    </l-map>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";



export default {
  name: "LeafletMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },
  props: ['countries', 'l10n'],
  data: function () {
    return {
      zoom: 3.5,
      center: latLng(20, 0),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 3.5,
      currentCenter: latLng(20, 0),
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    };
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    ll(lat, lng) {
      return latLng(lat, lng);
    }
  }
};
</script>

<style>
html {
    height: 90%;
}
body, .container-fluid, .container-fluid > .row, .Countries.view.col, #map-app {
 height: 100%;
}

#map-app .leaflet-map {
    height: 100%;
    width: 100%;
}
</style>